// DSS Documentation on SocoSearchPipe - http://tiny.sc/cgsocosearchpipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'socoSearch',
    pure: false
})
export class SocoSearchPipe implements PipeTransform {
    /* istanbul ignore next */
    transform(value: Array<any>, searchTerm: string, properties?: string | string[]) {
        if (!value || Object.prototype.toString.call(value) !== '[object Array]' || value.length < 1) {
            return value;
        }
        return value.filter((item) => {
            if (!searchTerm) {
                return true;
            }
            const matcher = new RegExp(searchTerm.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i');
            if (!properties) {
                return matcher.test(item);
            } else {
                if (typeof properties === 'string') {
                    return matcher.test(item[properties]);
                } else {
                    for (let i = 0; i < properties.length; i++) {
                        if (item.hasOwnProperty(properties[i]) && matcher.test(item[properties[i]])) {
                            return true;
                        }
                    }
                    return false;
                }
            }
        });
    }
}
